































































































// Vue
import { computed, defineComponent, Ref, ref, watch } from '@vue/composition-api'

// componnents
import { PageHeader } from '@/components'
import { DatePicker } from '@/components/form'
import { FiltersFormTaskSheet, TableTask, ModalAddSupportStaff } from '@/components/taskSheet'

// services
import {
    AreaService,
    HeadquarterService
} from '@/services/config'
import { TaskSheetService } from '@/services/taskSheet'

// Models
import { FiltersFormModel, EmployeeWithTime, TaskSheet, CreateTaskSheetInput, TaskSheetModel } from '@/models/taskSheet'
import {
    AreaModel,
    HeadquarterModel,
    IEmployee
} from '@/models/config'

// utils
import { loading, alerts, createHtmlEmploteeInfo, dateLibs, subtractTime, msToHours } from '@/utils'
import { isWorkingInDate } from '@/utils/employee'
import { totalDailyControl, createItemToTaskSheet } from '@/utils/taskSheet'
import moment from 'moment'

export default defineComponent({
  name: 'FormTaskSheet',
  components: {
    PageHeader,
    FiltersFormTaskSheet,
    DatePicker,
    TableTask,
    ModalAddSupportStaff
  },
  setup (props, { root: { $router, $route } }) {
    const actionForm = ref('save')
    const idEditTask: Ref<number|null> = ref(null)
    const showModalAddSupportStaff = ref(false)
    const title = ref('Crear/Editar Tareo')
    const areas: Ref<AreaModel[]> = ref([])
    const headquarters: Ref<HeadquarterModel[]> = ref([])
    const date = ref('')
    const numberDay = computed(() => {
      if (date.value) {
        return moment(date.value).day()
      }
      return null
    })
    const filters: Ref<FiltersFormModel> = ref({
      areaId: null,
      workType: null,
      workCategory: null,
      headquarterId: null,
      subareaId: null
    })
    const items = ref([
      {
        text: 'Dashboard',
        to: { name: 'home' }
      },
      {
        text: 'Tareo',
        to: { name: 'task-sheets' }
      },
      {
        text: 'Crear/Editar',
        active: true
      }
    ])
    const itemsEmployees: Ref<EmployeeWithTime[]> = ref([])
    const taskSheet: Ref<TaskSheet> = ref({
      items: [],
      timeTotal: 0,
      timeExtraTotal25: 0,
      timeExtraTotal35: 0,
      timeNocturnalTotal: 0,
      timenNocturnalTotal25: 0,
      timenNocturnalTotal35: 0
    })
    const isValidFormFilters = () => {
      const keys = (Object.keys(filters.value) as Array<keyof FiltersFormModel>)
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i]
        if (!filters.value[key]) {
          return false
        }
      }
      return true
    }
    const canSearch = computed(() => {
      if (!isValidFormFilters() || !date.value) {
        return false
      }
      return true
    })

    const createTaskSheet = () => {
      taskSheet.value = {
        items: itemsEmployees.value.filter(employeeTime => isWorkingInDate(employeeTime.employee, date.value)).map(employee => {
          return createItemToTaskSheet(employee, filters.value.workType ?? 0, false, numberDay.value)
        }),
        timeTotal: 0,
        timeExtraTotal25: 0,
        timeExtraTotal35: 0,
        timeNocturnalTotal: 0,
        timenNocturnalTotal25: 0,
        timenNocturnalTotal35: 0
      }
    }

    const createTaskByTask = (taskModel: TaskSheetModel) => {
      date.value = taskModel.date
      filters.value = {
        areaId: taskModel.area_id,
        workType: taskModel.work_type,
        workCategory: taskModel.work_category,
        headquarterId: taskModel.headquarter_id,
        subareaId: null
      }
      setTimeout(() => {
        filters.value.subareaId = taskModel.sub_area_id
      }, 300)
      taskSheet.value = {
        items: taskModel.items.map(itemTask => {
          const timeLunch = msToHours(subtractTime(itemTask.lunch_time_entry, itemTask.lunch_time_ends))
          return {
            employeeId: itemTask.employee_id,
            employeeText: createHtmlEmploteeInfo(itemTask.employee),
            employeeBaseSalary: itemTask.employee_base_salary,
            timeInDevice: dateLibs.getOnlyHourAndMinute(itemTask.time_in_device),
            timeOutDevice: dateLibs.getOnlyHourAndMinute(itemTask.time_out_device),
            timeIn: dateLibs.getOnlyHourAndMinute(itemTask.time_in),
            timeOut: dateLibs.getOnlyHourAndMinute(itemTask.time_out),
            timeWorkingTotal: 0,
            timeTotal: itemTask.time_total_day,
            timeExtra25: itemTask.time_total_extra_day_25,
            timeExtra35: itemTask.time_total_extra_day_35,
            timeTotalN: itemTask.time_total_nocturnal,
            timeExtra25N: itemTask.time_total_extra_nocturnal_25,
            timeExtra35N: itemTask.time_total_extra_nocturnal_35,
            timeHed: itemTask.time_hed,
            workShift: {
              workShiftId: itemTask.work_shift_id,
              isCumulative: itemTask.is_cumulative,
              isNocturnal: itemTask.is_nocturnal,
              checkin_time: itemTask.checkin_time,
              checkout_time: itemTask.checkout_time,
              lunch_time_entry: itemTask.lunch_time_entry,
              lunch_time_ends: itemTask.lunch_time_ends
            },
            timeLunch: timeLunch,
            cumulativeHoursDay: itemTask.time_cumulative,
            cumulativeHoursOld: itemTask.time_cumulative_week,
            condition: itemTask.condition,
            workType: itemTask.work_type,
            observations: itemTask.observations,
            viewWorkDescription: false,
            dailyControls: itemTask.dailyControls.map(daily => {
              return {
                id: daily.daily_control_id,
                workDescriptionId: daily.work_description_id,
                name: daily.workDescription.name,
                price: daily.price,
                amount: daily.amount,
                total: daily.total
              }
            }),
            amounts: totalDailyControl(itemTask.dailyControls.map(d => {
              return d.dailyControl
            })),
            hasPermission: itemTask.permissionControl ? itemTask.permissionControl.length > 0 : false,
            permissions: itemTask.permissionControl ? itemTask.permissionControl.map(permission => {
              return {
                ...permission.permissionControl
              }
            }) : [],
            isSupport: itemTask.is_support,
            lunch: itemTask.lunch,
            ajeno: itemTask.ajeno,
            feriado: itemTask.feriado,
            lunch_rate_id: itemTask.lunch_rate_id,
            amount_lunch: itemTask.amount_lunch,
            lunch_rate: itemTask.lunch_rate,
            price_lunch: itemTask.price_lunch,
            timeTotalReal: itemTask.time_total_real
          }
        }),
        timeTotal: taskModel.time_total_day,
        timeExtraTotal25: taskModel.time_total_extra_day_25,
        timeExtraTotal35: taskModel.time_total_extra_day_35,
        timeNocturnalTotal: taskModel.time_total_nocturnal,
        timenNocturnalTotal25: taskModel.time_total_extra_nocturnal_25,
        timenNocturnalTotal35: taskModel.time_total_extra_nocturnal_35
      }
      idEditTask.value = taskModel.id
    }

    const getById = (id: number) => {
      loading('show')
      TaskSheetService.getById(id).then(response => {
        if (response) {
          createTaskByTask(response)
          actionForm.value = 'update'
        } else {
          alerts.error('El ID envidao no es validó')
          $router.push({
            name: 'task-sheets'
          })
        }
      }).catch(() => {
        alerts.error()
      }).finally(() => {
        loading('hide')
      })
    }

    const searchAndCreateSheet = async () => {
      loading('show')
      TaskSheetService.existsTaskSheetByFilters(filters.value, date.value).then(response => {
        if (response.exists && response.taskId) {
          getById(response.taskId)
        } else {
        TaskSheetService.searchAndCreateTaskSheet(filters.value, date.value)
        .then(response => {
          itemsEmployees.value = response.data.employees
          createTaskSheet()
        })
        .catch(() => {
          alerts.error()
        })
        .finally(() => {
          loading('hide')
        })
        }
      })
    }

    const isValidFilters = (): boolean => {
      const keys = (Object.keys(filters.value) as Array<keyof FiltersFormModel>)
      const elementsNull = keys.find(k => !filters.value[k])
      if (elementsNull && elementsNull.length > 0) {
        return false
      }
      return true
    }

    const initValues = () => {
      taskSheet.value = {
        items: [],
        timeTotal: 0,
        timeExtraTotal25: 0,
        timeExtraTotal35: 0,
        timeNocturnalTotal: 0,
        timenNocturnalTotal25: 0,
        timenNocturnalTotal35: 0
      }
      actionForm.value = 'save'
    }

    const saveTaskSheet = async () => {
      if (!isValidFilters()) {
        return alerts.error('Debe completar todos los filtros')
      }
      if (!date.value) {
        return alerts.error('Debe completar la fecha')
      }
      loading('show')
      const formTask: CreateTaskSheetInput = {
        date: date.value,
        work_type: Number(filters.value.workType),
        work_category: Number(filters.value.workCategory),
        headquarter_id: Number(filters.value.headquarterId),
        area_id: Number(filters.value.areaId),
        sub_area_id: Number(filters.value.subareaId),
        time_total_day: taskSheet.value.timeTotal,
        time_total_extra_day_25: taskSheet.value.timeExtraTotal25,
        time_total_extra_day_35: taskSheet.value.timeExtraTotal35,
        time_total_nocturnal: taskSheet.value.timeNocturnalTotal,
        time_total_extra_nocturnal_25: taskSheet.value.timenNocturnalTotal25,
        time_total_extra_nocturnal_35: taskSheet.value.timenNocturnalTotal35,
        items: taskSheet.value.items.map(item => {
          return {
            employee_id: item.employeeId,
            employee_base_salary: item.employeeBaseSalary,
            time_in_device: item.timeInDevice,
            time_out_device: item.timeOutDevice,
            time_in: item.timeIn,
            time_out: item.timeOut,
            time_total_day: item.timeTotal,
            time_total_extra_day_25: item.timeExtra25,
            time_total_extra_day_35: item.timeExtra35,
            time_total_nocturnal: item.timeTotalN,
            time_total_extra_nocturnal_25: item.timeExtra25N,
            time_total_extra_nocturnal_35: item.timeExtra35N,
            time_hed: item.timeHed,
            time_total_real: item.timeTotalReal,
            condition: item.condition,
            work_type: item.workType,
            observations: item.observations,
            work_shift_id: item.workShift.workShiftId,
            checkin_time: item.workShift.checkin_time,
            checkout_time: item.workShift.checkout_time,
            lunch_time_entry: item.workShift.lunch_time_entry,
            lunch_time_ends: item.workShift.lunch_time_ends,
            is_cumulative: item.workShift.isCumulative,
            time_cumulative: item.cumulativeHoursDay,
            is_nocturnal: item.workShift.isNocturnal,
            is_support: item.isSupport,
            lunch: item.lunch,
            ajeno: item.ajeno,
            lunch_rate_id: item.lunch_rate_id,
            amount_lunch: item.lunch ? item.amount_lunch : 1,
            price_lunch: actionForm.value === 'save' && (item.lunch && item.lunch_rate?.price) ? item.lunch_rate?.price : (actionForm.value === 'update' ? item.price_lunch : 0),
            dailyControls: item.dailyControls.map(daily => {
              return {
                  daily_control_id: daily.id,
                  work_description_id: daily.workDescriptionId,
                  amount: daily.amount,
                  price: daily.price,
                  total: daily.total,
                  date: date.value
                }
            }),
            permissionControls: item.permissions.map(permission => {
              return {
                permission_control_id: permission.id,
                date_end: permission.date_end,
                date_start: permission.date_start,
                observations: permission.observations
              }
            })
          }
        })
      }
      if (actionForm.value === 'save') {
        TaskSheetService.create(formTask).then(res => {
          if (res.success) {
            alerts.success()
            initValues()
          } else {
            alerts.error(res.msg)
          }
        }).catch(() => {
          alerts.error()
        }).finally(() => {
          loading('hide')
        })
      } else {
        if (idEditTask.value) {
          TaskSheetService.update(idEditTask.value, formTask).then(res => {
            if (res.success) {
              alerts.success()
              initValues()
            } else {
              alerts.error(res.msg)
            }
          }).catch(() => {
            alerts.error()
          }).finally(() => {
            loading('hide')
          })
        }
      }
    }

    const employeeIdExceptForSupport = computed(() => {
      return taskSheet.value.items.map(item => {
        return Number(item.employeeId)
      })
    })

    const addSupportStaff = (employee: IEmployee) => {
      showModalAddSupportStaff.value = false
      const item: EmployeeWithTime = {
        employee: employee,
        timeInDevice: '',
        timeOutDevice: '',
        timeCumulative: 0,
        dailyControls: [],
        permisssionControl: []
      }
     taskSheet.value.items.push(createItemToTaskSheet(item, filters.value.workType ?? 0, true))
    }

    const removeSupportStaff = (employeeId: number) => {
      for (let i = 0; i < taskSheet.value.items.length; i++) {
        const item = taskSheet.value.items[i]
        if (Number(item.employeeId) === employeeId) {
          taskSheet.value.items.splice(i, 1)
          break
        }
      }
    }

    watch(() => filters.value.workType, () => {
      loading('show')
      itemsEmployees.value = []
      loading('hide')
    })

    const getAll = async () => {
      loading('show')
      areas.value = await AreaService.getActivated()
      headquarters.value = await HeadquarterService.getAllActivate()
      if ($route.params?.id) {
        const id = Number($route.params.id)
        getById(id)
      } else {
        loading('hide')
      }
    }

    getAll()

    const back = () => {
      $router.push({
        name: 'task-sheets'
      })
    }

    return {
      title,
      areas,
      headquarters,
      date,
      filters,
      items,
      itemsEmployees,
      taskSheet,
      canSearch,
      searchAndCreateSheet,
      saveTaskSheet,
      actionForm,
      showModalAddSupportStaff,
      employeeIdExceptForSupport,
      addSupportStaff,
      removeSupportStaff,
      back,
      numberDay
    }
  }
})
